import { render, staticRenderFns } from "./batchSubmission.vue?vue&type=template&id=140b94b0"
import script from "./batchSubmission.vue?vue&type=script&lang=js"
export * from "./batchSubmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports